import {
  GIAGOIMFY_COUNT_ASSIGN_SUCCESS,
  GIAGOIMFY_HISTORY_LIST_SUCCESS,
  GIAGOIMFY_IMPORT_SUCCESS,
  GIAGOIMFY_LIST_SUCCESS,
  GIAGOIMFY_LIST_NO_LIMIT_SUCCESS,
  GIAGOIMFY_NEW_CARE_SUCCESS,
  GIAGOIMFY_ONE_SUCCESS,
  GIAGOIMFY_UPDATE_FILTER,
  GIAGOIMFY_SAVE_SUCCESS,
} from 'src/actions/giagoimfy.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    ten_goi_cuoc: '',
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  goiCuocItems: [],
  goiCuocTotal: 0,
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
}

const giagoimfyReducer = (state = initState, action) => {
  switch (action.type) {
    case GIAGOIMFY_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case GIAGOIMFY_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case GIAGOIMFY_LIST_NO_LIMIT_SUCCESS: {
      return {
        ...state,
        goiCuocItems: action.data.items,
        goiCuocTotal: action.data.total,
      }
    }
    case GIAGOIMFY_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case GIAGOIMFY_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case GIAGOIMFY_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case GIAGOIMFY_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case GIAGOIMFY_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case GIAGOIMFY_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    default: {
      return state;
    }
  }
}
export default giagoimfyReducer